import _regenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, setToken } from "@/utils/auth";
import getPageTitle from "@/utils/get-page-title";
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ["/login", "/auth-redirect", "/jump", "/Navigation", "/NavigationQuery", "/Navigationmobile", "/NavigamoQuery", "/feedback", "/feedbackRecord", "/messageDetails", "/messageView", "/changePassword", "/abnormalFeedback", "/filterCriteria", '/NavigationQuerywx', "/loginwx", "/homepagewx", "/orderInquiry"]; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var hasToken, hasMenu, res, accessRoutes, _hasMenu, _res, _accessRoutes, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          console.log(to.meta, "to.meta");
          // start progress bar
          NProgress.start();

          // set page title
          if (to.meta.title == "eZ-Freight") {
            document.title = to.meta.title;
          } else {
            document.title = getPageTitle(to.meta.title, to.meta.zhTitle);
          }

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.n = 9;
            break;
          }
          if (!(store.getters.isLock && to.path !== "/lockScreen" && to.path !== "/login")) {
            _context.n = 1;
            break;
          }
          next({
            path: "/lockScreen"
          });
          NProgress.done();
          _context.n = 8;
          break;
        case 1:
          if (!(to.path === "/login")) {
            _context.n = 2;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: "/"
          });
          NProgress.done();
          _context.n = 8;
          break;
        case 2:
          if (to.path === "/home") {
            if (to.query.token) {
              store.commit("user/SET_TOKEN", to.query.token);
              setToken(to.query.token);
            }
          }
          hasMenu = store.getters.menuList && store.getters.menuList.length > 0;
          if (!hasMenu) {
            _context.n = 3;
            break;
          }
          next();
          _context.n = 8;
          break;
        case 3:
          _context.p = 3;
          _context.n = 4;
          return store.dispatch("user/getInfo");
        case 4:
          res = _context.v;
          _context.n = 5;
          return store.dispatch("permission/generateRoutes", res);
        case 5:
          accessRoutes = _context.v;
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.n = 8;
          break;
        case 6:
          _context.p = 6;
          _t = _context.v;
          _context.n = 7;
          return store.dispatch("user/resetToken");
        case 7:
          if (_t && typeof _t == "string") Message.error(_t || "Has Error");
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 8:
          _context.n = 19;
          break;
        case 9:
          if (!(whiteList.indexOf(to.path) !== -1)) {
            _context.n = 10;
            break;
          }
          // in the free login whitelist, go directly
          next();
          _context.n = 19;
          break;
        case 10:
          if (!(to.path === "/home")) {
            _context.n = 18;
            break;
          }
          if (!to.query.token) {
            _context.n = 16;
            break;
          }
          store.commit("user/SET_TOKEN", to.query.token);
          setToken(to.query.token);
          _hasMenu = store.getters.menuList && store.getters.menuList.length > 0;
          if (!_hasMenu) {
            _context.n = 11;
            break;
          }
          next();
          _context.n = 15;
          break;
        case 11:
          _context.p = 11;
          _context.n = 12;
          return store.dispatch("user/getInfo");
        case 12:
          _res = _context.v;
          _context.n = 13;
          return store.dispatch("permission/generateRoutes", _res);
        case 13:
          _accessRoutes = _context.v;
          router.addRoutes(_accessRoutes);
          next("/home");
          _context.n = 15;
          break;
        case 14:
          _context.p = 14;
          _t2 = _context.v;
          next("/login");
          NProgress.done();
        case 15:
          _context.n = 17;
          break;
        case 16:
          next("/login");
          NProgress.done();
        case 17:
          _context.n = 19;
          break;
        case 18:
          // other pages that do not have permissionEle to access are redirected to the login page.
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 19:
          return _context.a(2);
      }
    }, _callee, null, [[11, 14], [3, 6]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});